export default {
  // 元素被挂载到DOM后执行
  mounted(el, binding) {
    // 定义点击事件处理函数
    const handler = (event) => {
      // 检查点击事件是否发生在指令绑定的元素内部
      // 1. 元素本身是否可见（display不为none）
      // 2. 点击的目标是否是元素本身或其子元素
      if (!el || el.style.display === 'none' || el.contains(event.target)) {
        return; // 如果点击发生在内部，不执行任何操作
      }
      
      // 调用绑定的值（应该是一个函数）
      binding.value(event);
    };
    
    // 将处理函数保存在元素上，以便后续清理
    el.__clickOutsideHandler__ = handler;
    
    // 添加事件监听，使用捕获模式以确保在可能的事件阻止之前执行
    document.addEventListener('click', handler, true);
  },
  
  // 元素被卸载前执行清理
  beforeUnmount(el) {
    if (el.__clickOutsideHandler__) {
      // 移除事件监听
      document.removeEventListener('click', el.__clickOutsideHandler__, true);
      // 删除对处理函数的引用
      delete el.__clickOutsideHandler__;
    }
  }
};
